import React from 'react';

export default function TrophyIcon({ className, ...props }) {
    return (
        <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                // eslint-disable-next-line max-len
                d="M14.9106 10.5957C14.9504 10.4873 14.9894 10.3774 15.0269 10.265C15.8504 7.79453 16.0094 4.68545 15.9998 2.30992H19.395C19.2228 3.3423 18.8438 4.87518 18.1422 6.4018C17.3096 8.21373 16.2271 9.61697 14.9106 10.5957ZM1.60499 2.30992H4.41173C4.45005 4.56834 4.65246 7.75171 5.28034 9.91221C4.32333 9.00011 3.51299 7.82775 2.85782 6.4018C2.15615 4.87518 1.77711 3.3423 1.60499 2.30992ZM20.2487 0.807424H15.9725C15.9633 0.513853 15.9531 0.242152 15.9431 0H4.43569C4.42459 0.203588 4.41532 0.477794 4.40973 0.807424H0.751235C0.541637 0.807424 0.341471 0.89507 0.199235 1.04916C0.0570823 1.20316 -0.0143697 1.40959 0.00240815 1.6186C0.0238605 1.8873 0.248317 4.32168 1.49247 7.02917C2.6751 9.60262 4.39587 11.5169 6.50671 12.623C7.29636 13.8711 8.19485 14.568 9.22064 14.8311C9.19392 15.24 9.14509 15.5771 9.06237 15.7694C8.23333 17.6961 5.23134 18.2056 5.10881 18.2056C4.98627 18.2056 4.84996 18.2211 4.84996 18.4074V20.2808C4.84996 20.3894 4.94528 20.4942 5.06123 20.4942H15.3811C15.4936 20.4942 15.5549 20.405 15.5549 20.2768V18.4541C15.5549 18.291 15.4016 18.1978 15.3299 18.1978C15.2583 18.1978 11.9866 17.5708 11.3851 15.777C11.3166 15.5472 11.2705 15.1994 11.2401 14.7957C12.076 14.5315 12.8921 13.9393 13.5967 13.0342C16.1183 12.0328 18.1616 9.95804 19.5075 7.02917C20.7517 4.32168 20.9761 1.8873 20.9976 1.6186C21.0143 1.40959 20.9429 1.20316 20.8008 1.04916C20.6585 0.89507 20.4584 0.807424 20.2487 0.807424Z"
                fill="currentColor"
            />
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/lib/icons/TrophyIcon.jsx